// import React from 'react';
// import { Routes, Route, Navigate } from 'react-router-dom';

// import Homepage from './pages/Homepage';
// import RegisterSchool from './pages/RegisterSchool';
// import ContactForm from './pages/Contact/contactForm';
// import Navbar from './components/Navbar';
// import Footer from './components/Footer';

// const App = () => {
//   return (
//     <div className="w-full min-h-screen overflow-x-hidden bg-white flex flex-col">
//       <Navbar />

//       {/* pt matches the fixed navbar's height so content never sits under it */}
//       <main className="flex-1 pt-[76px] w-full">
//         <Routes>
//           <Route path="/" element={<Homepage />} />
//           <Route path="/contactForm" element={<ContactForm />} />
//           <Route path="/registerSchool" element={<RegisterSchool />} />
//           <Route path="*" element={<Navigate to="/" />} />
//         </Routes>
//       </main>

//       <Footer />
//     </div>
//   );
// };

// export default App;


import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Homepage from './pages/Homepage';
import RegisterSchool from './pages/RegisterSchool';
import ContactForm from './pages/Contact/contactForm';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

import AdminLogin from './pages/MainErpManage/AdminLogin';
import AdminDashboard from './pages/MainErpManage/AdminDashboard';
import AdminProtectedRoute from './pages/MainErpManage/AdminProtectedRoutes';

// Public marketing pages keep the shared Navbar/Footer.
// The admin console renders full-screen, without them.
const PublicLayout = ({ children }) => (
  <>
    <Navbar />
    <main className="flex-1 pt-[76px] w-full">{children}</main>
    <Footer />
  </>
);

const App = () => {
  return (
    <div className="w-full min-h-screen overflow-x-hidden bg-white flex flex-col">
      <Routes>
        <Route path="/" element={<PublicLayout><Homepage /></PublicLayout>} />
        <Route path="/contactForm" element={<PublicLayout><ContactForm /></PublicLayout>} />
        <Route path="/registerSchool" element={<PublicLayout><RegisterSchool /></PublicLayout>} />

        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin/dashboard"
          element={
            <AdminProtectedRoute>
              <AdminDashboard />
            </AdminProtectedRoute>
          }
        />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </div>
  );
};

export default App;
